import { render, staticRenderFns } from "./MatchIntroduce.vue?vue&type=template&id=2b13e33c&scoped=true&"
import script from "./MatchIntroduce.vue?vue&type=script&lang=js&"
export * from "./MatchIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./MatchIntroduce.vue?vue&type=style&index=0&id=2b13e33c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b13e33c",
  null
  
)

export default component.exports